export type FuenteClip = 'programa' | 'locutor' | 'entrevista' | 'evento' | 'concurso';

export type DuracionClip = '15' | '30' | '60' | '180';

export interface Clip {
  id: number;
  titulo: string;
  fuente: FuenteClip;
  duracion: DuracionClip;
  duracionSegundos: number;
  descripcion: string;
  radioNombre: string;
  radioFrecuencia: string;
  radioLogo: string;
  locutorNombre?: string;
  locutorAvatar?: string;
  programaNombre?: string;
  imagenUrl: string;
  fechaCreacion: string;
  esTendencia: boolean;
  vistas: number;
  compartidos: number;
  scoreTotal: number;
  tags: string[];
  fuenteUrl?: string;
  // Referencia al motor unificado Admin Radio (contentMaster)
  canonicalSource?: {
    type: 'live' | 'video' | 'post' | 'recording';
    id: string;
  };
}

export interface ScoreAccionClip {
  id: string;
  accion: string;
  icono: string;
  color: string;
  descripcion: string;
  puntos: number;
}

export interface ReglaClip {
  id: number;
  titulo: string;
  descripcion: string;
  icono: string;
  gradiente: string;
}

export const coverImage = 'https://readdy.ai/api/search-image?query=Modern%20video%20editing%20studio%20with%20multiple%20monitors%20showing%20timeline%20waveforms%2C%20professional%20broadcast%20editing%20suite%2C%20warm%20cinematic%20lighting%2C%20creative%20post%20production%20environment%2C%20sleek%20dark%20workstation%20with%20colorful%20waveform%20displays%2C%20content%20creation%20atmosphere%2C%20editorial%20photography%20with%20dramatic%20ambient%20glow&width=1600&height=900&seq=clips-hero-x1&orientation=landscape';

export const clips: Clip[] = [
  {
    id: 1,
    titulo: 'Valentina Ríos anuncia el Summer Fest — Momento Épico',
    fuente: 'programa',
    duracion: '30',
    duracionSegundos: 30,
    descripcion: 'El momento exacto en que Valentina Ríos anunció el Summer Fest RFW 2026 al aire. La reacción de la comunidad en vivo fue increíble, con más de 2000 mensajes en Cabina en menos de un minuto. Este clip captura la emoción pura del anuncio más esperado del año.',
    radioNombre: 'Estéreo Capital',
    radioFrecuencia: '102.1 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Modern%20radio%20station%20square%20logo%2C%20clean%20minimalist%20design%2C%20warm%20golden%20and%20amber%20emblem%2C%20broadcast%20waves%20icon%2C%20elegant%20flat%20vector%20style&width=120&height=120&seq=clips-logo-capital&orientation=squarish',
    locutorNombre: 'Valentina Ríos',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20portrait%2C%20warm%20confident%20smile%2C%20modern%20studio%20headphones%2C%20broadcast%20booth%20background%2C%20soft%20natural%20lighting%2C%20editorial%20style&width=80&height=80&seq=clips-avatar-vrios&orientation=squarish',
    programaNombre: 'Tardes con Vale',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20radio%20studio%20moment%2C%20female%20host%20with%20raised%20arms%20making%20exciting%20announcement%2C%20golden%20confetti%20falling%2C%20studio%20lights%20flaring%2C%20microphone%20on%20desk%2C%20energetic%20broadcast%20atmosphere%2C%20cinematic%20editorial%20photography%20with%20warm%20amber%20tones&width=1600&height=900&seq=clips-img-anuncio&orientation=landscape',
    fechaCreacion: '2026-06-20T17:30:00',
    esTendencia: true,
    vistas: 28450,
    compartidos: 12580,
    scoreTotal: 6920,
    tags: ['anuncio', 'festival', 'Summer Fest', 'viral'],
    fuenteUrl: '/radio/102.1',
    canonicalSource: { type: 'live', id: 'live-005' },
  },
  {
    id: 2,
    titulo: 'Diego Montenegro entrevista a Andrés Castillo — Batalla de Locutores',
    fuente: 'entrevista',
    duracion: '180',
    duracionSegundos: 180,
    descripcion: 'Tres minutos de pura química entre Diego Montenegro y Andrés Castillo. Los dos locutores más carismáticos del dial RFW cara a cara por primera vez. Anécdotas de sus inicios, competencia amistosa de imitaciones, y el desafío de cantar un cover en vivo que terminó en ovación de la comunidad.',
    radioNombre: 'La Kalle 99.9',
    radioFrecuencia: '99.9 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Pop%20music%20radio%20station%20square%20logo%2C%20neon%20microphone%20icon%2C%20vibrant%20pink%20and%20coral%20emblem%2C%20modern%20flat%20vector&width=120&height=120&seq=clips-logo-kalle&orientation=squarish',
    locutorNombre: 'Diego Montenegro',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Young%20male%20pop%20radio%20DJ%20portrait%2C%20stylish%20casual%20outfit%2C%20energetic%20smile%2C%20neon%20lit%20studio%20background%2C%20modern%20vibe&width=80&height=80&seq=clips-avatar-dmontenegro&orientation=squarish',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Two%20charismatic%20radio%20hosts%20in%20energetic%20studio%20conversation%2C%20both%20laughing%20and%20gesturing%2C%20colorful%20neon%20studio%20lighting%2C%20microphones%20between%20them%2C%20fun%20competitive%20atmosphere%2C%20candid%20broadcast%20photography&width=1600&height=900&seq=clips-img-batalla&orientation=landscape',
    fechaCreacion: '2026-06-19T15:00:00',
    esTendencia: true,
    vistas: 22100,
    compartidos: 9870,
    scoreTotal: 5430,
    tags: ['entrevista', 'locutores', 'humor', 'batalla'],
    fuenteUrl: '/host/diego-montenegro',
  },
  {
    id: 3,
    titulo: 'Ganador del Concurso de Talentos — Cover de Bailando que Todos Comparten',
    fuente: 'concurso',
    duracion: '60',
    duracionSegundos: 60,
    descripcion: 'Diego Vargas ganó el Concurso de Talentos RFW con este cover acústico de Bailando. Un minuto de guitarra y voz que conquistó a los jueces y a toda la comunidad. El clip que más se compartió en la historia de RFW, con oyentes de 12 países diferentes reproduciéndolo.',
    radioNombre: 'Estéreo Capital',
    radioFrecuencia: '102.1 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Modern%20radio%20station%20square%20logo%2C%20clean%20minimalist%20design%2C%20warm%20golden%20and%20amber%20emblem%2C%20broadcast%20waves%20icon%2C%20elegant%20flat%20vector%20style&width=120&height=120&seq=clips-logo-capital2&orientation=squarish',
    locutorNombre: 'Diego Vargas',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Latino%20man%20with%20acoustic%20guitar%2C%20stylish%20casual%20look%2C%20confident%20friendly%20expression%2C%20warm%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=clips-avatar-dvargas&orientation=squarish',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Young%20musician%20performing%20acoustic%20guitar%20cover%20in%20radio%20studio%2C%20warm%20spotlight%20on%20performer%2C%20microphone%20on%20stand%2C%20intimate%20performance%20atmosphere%2C%20golden%20hour%20lighting%2C%20emotional%20music%20moment%2C%20editorial%20concert%20photography&width=1600&height=900&seq=clips-img-talento&orientation=landscape',
    fechaCreacion: '2026-06-18T19:00:00',
    esTendencia: true,
    vistas: 45210,
    compartidos: 23450,
    scoreTotal: 12890,
    tags: ['concurso', 'talento', 'cover', 'viral', 'música'],
    fuenteUrl: '/eventos',
  },
  {
    id: 4,
    titulo: 'Final del Campeonato — El Gol que Hizo Gritar a Todo un País',
    fuente: 'evento',
    duracion: '30',
    duracionSegundos: 30,
    descripcion: 'Treinta segundos que paralizaron Costa Rica. La narración del gol de la final del campeonato nacional por Javier Solís desde el Estadio Nacional. El rugido de la multitud de fondo, la emoción en la voz del narrador, y la explosión de alegría en la Cabina con más de 5000 mensajes simultáneos.',
    radioNombre: 'Deportes Total Radio',
    radioFrecuencia: '101.1 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Sports%20radio%20station%20square%20logo%2C%20soccer%20ball%20and%20microphone%20icon%2C%20bold%20dynamic%20emblem%2C%20warm%20red%20and%20gold%20flat%20vector%20style&width=120&height=120&seq=clips-logo-deportes&orientation=squarish',
    locutorNombre: 'Javier Solís',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Male%20sports%20commentator%20portrait%2C%20professional%20headset%2C%20enthusiastic%20expression%2C%20broadcast%20booth%2C%20dramatic%20stadium%20lighting&width=80&height=80&seq=clips-avatar-jsolis&orientation=squarish',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Sports%20stadium%20panoramic%20view%20during%20championship%20final%20goal%20moment%2C%20packed%20crowd%20with%20team%20colors%20erupting%20in%20celebration%2C%20dramatic%20stadium%20lighting%20at%20dusk%2C%20broadcast%20commentary%20booth%20overlooking%20the%20field%2C%20intense%20sports%20atmosphere%2C%20professional%20sports%20photography&width=1600&height=900&seq=clips-img-gol&orientation=landscape',
    fechaCreacion: '2026-06-16T18:45:00',
    esTendencia: false,
    vistas: 38900,
    compartidos: 18700,
    scoreTotal: 10230,
    tags: ['deportes', 'fútbol', 'gol', 'final', 'épico'],
    fuenteUrl: '/radio/101.1',
  },
  {
    id: 5,
    titulo: 'Natalia Campos Presenta su Nuevo Programa — Adelanto Exclusivo',
    fuente: 'locutor',
    duracion: '15',
    duracionSegundos: 15,
    descripcion: 'Quince segundos que cambiaron la programación de RFW. Natalia Campos anunció su nuevo programa matutino con un adelanto que dejó a todos con ganas de más. La promesa de un show que mezcla música, entrevistas y la energía que solo Natalia puede traer a las mañanas.',
    radioNombre: 'Radio Nueva Actitud',
    radioFrecuencia: '102.5 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Modern%20pop%20radio%20station%20square%20logo%2C%20minimalist%20sunburst%20icon%2C%20warm%20golden%20and%20coral%20emblem%2C%20clean%20elegant%20vector&width=120&height=120&seq=clips-logo-actitud&orientation=squarish',
    locutorNombre: 'Natalia Campos',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Female%20radio%20host%20portrait%2C%20warm%20friendly%20smile%2C%20modern%20casual%20style%2C%20bright%20studio%20with%20plants%2C%20natural%20golden%20lighting&width=80&height=80&seq=clips-avatar-ncampos&orientation=squarish',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Radio%20host%20making%20exciting%20announcement%20in%20bright%20modern%20studio%2C%20morning%20sun%20streaming%20through%20windows%2C%20plants%20and%20warm%20decor%2C%20genuine%20surprised%20expression%2C%20lifestyle%20broadcast%20photography&width=1600&height=900&seq=clips-img-adelanto&orientation=landscape',
    fechaCreacion: '2026-06-19T08:00:00',
    esTendencia: true,
    vistas: 18500,
    compartidos: 7890,
    scoreTotal: 4230,
    tags: ['locutora', 'anuncio', 'programa nuevo', 'mañanas'],
    fuenteUrl: '/host/natalia-campos',
  },
  {
    id: 6,
    titulo: 'Debate del Futuro de la Radio — Los 5 Locutores que No te Podés Perder',
    fuente: 'entrevista',
    duracion: '180',
    duracionSegundos: 180,
    descripcion: 'El momento más intenso del debate sobre el futuro de la radio digital. Cinco locutores de diferentes géneros discutiendo hacia dónde va el medio. Podcasts vs radio en vivo, interacción con oyentes, monetización, y el rol de la inteligencia artificial. Este clip captura el intercambio más encendido de la noche.',
    radioNombre: 'RFW Radio',
    radioFrecuencia: '87.00 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Official%20RFW%20network%20square%20logo%2C%20radio%20frequency%20waves%20emblem%2C%20warm%20red%20and%20amber%20gradient%2C%20professional%20broadcast%20identity%2C%20clean%20modern%20flat%20vector&width=120&height=120&seq=clips-logo-rfw&orientation=squarish',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Professional%20panel%20discussion%20in%20modern%20broadcast%20studio%2C%20five%20diverse%20speakers%20at%20curved%20desk%20with%20microphones%2C%20animated%20conversation%2C%20warm%20studio%20lighting%2C%20intellectual%20debate%20atmosphere%2C%20media%20conference%20photography&width=1600&height=900&seq=clips-img-debate&orientation=landscape',
    fechaCreacion: '2026-06-17T16:30:00',
    esTendencia: false,
    vistas: 12800,
    compartidos: 5430,
    scoreTotal: 2980,
    tags: ['debate', 'futuro', 'radio digital', 'panel'],
    fuenteUrl: '/radio/87.00',
    canonicalSource: { type: 'live', id: 'live-008' },
  },
  {
    id: 7,
    titulo: 'Maratón de Éxitos 90s — El Momento en que Todos Cantaron Juntos',
    fuente: 'programa',
    duracion: '60',
    duracionSegundos: 60,
    descripcion: 'Durante el Maratón de Éxitos 90s, sonó el tema más pedido por la comunidad y la Cabina explotó. Cientos de oyentes cantando la misma canción al mismo tiempo desde sus casas, trabajos y autos. Un minuto que demuestra que la radio sigue uniendo a la gente como nada más.',
    radioNombre: 'Radio Nueva Actitud',
    radioFrecuencia: '102.5 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Modern%20pop%20radio%20station%20square%20logo%2C%20minimalist%20sunburst%20icon%2C%20warm%20golden%20and%20coral%20emblem%2C%20clean%20elegant%20vector&width=120&height=120&seq=clips-logo-actitud2&orientation=squarish',
    locutorNombre: 'Natalia Campos',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Female%20radio%20host%20portrait%2C%20warm%20friendly%20smile%2C%20modern%20casual%20style%2C%20bright%20studio%20with%20plants%2C%20natural%20golden%20lighting&width=80&height=80&seq=clips-avatar-ncampos2&orientation=squarish',
    programaNombre: 'Maratón de Éxitos',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Retro%2090s%20themed%20radio%20studio%20with%20neon%20colors%20and%20vintage%20cassette%20tapes%2C%20boombox%20and%20CD%20player%20props%2C%20colorful%20disco%20ball%20reflections%2C%20host%20dancing%20with%20headphones%2C%20nostalgic%20music%20atmosphere%2C%20vibrant%20fun%20photography&width=1600&height=900&seq=clips-img-maraton&orientation=landscape',
    fechaCreacion: '2026-06-15T16:00:00',
    esTendencia: false,
    vistas: 15600,
    compartidos: 6780,
    scoreTotal: 3720,
    tags: ['90s', 'maratón', 'nostalgia', 'comunidad'],
    fuenteUrl: '/radio/102.5',
  },
  {
    id: 8,
    titulo: 'Andrés Castillo Toca un Solo de Guitarra en Vivo — El Estudio Casi se Cae',
    fuente: 'locutor',
    duracion: '60',
    duracionSegundos: 60,
    descripcion: 'Andrés Castillo, locutor de Rock Total Radio, sorprendió a todos improvisando un solo de guitarra eléctrica al aire durante 60 segundos. Lo que empezó como una broma terminó siendo uno de los momentos más compartidos del rock en RFW. La comunidad pidió que lo vuelva a hacer todos los viernes.',
    radioNombre: 'Rock Total Radio',
    radioFrecuencia: '95.3 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Rock%20radio%20station%20square%20logo%2C%20electric%20guitar%20silhouette%2C%20bold%20dynamic%20emblem%2C%20edgy%20flat%20vector%20style&width=120&height=120&seq=clips-logo-rock&orientation=squarish',
    locutorNombre: 'Andrés Castillo',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Rock%20radio%20host%20male%20portrait%2C%20leather%20jacket%2C%20confident%20expression%2C%20studio%20with%20guitars%20on%20wall%2C%20edgy%20lighting&width=80&height=80&seq=clips-avatar-acastillo&orientation=squarish',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Rock%20radio%20host%20playing%20electric%20guitar%20passionately%20in%20studio%2C%20dramatic%20red%20and%20blue%20stage%20lighting%2C%20guitars%20on%20wall%20background%2C%20energetic%20performance%20moment%2C%20music%20photography%20with%20motion%20blur&width=1600&height=900&seq=clips-img-solo&orientation=landscape',
    fechaCreacion: '2026-06-14T20:15:00',
    esTendencia: false,
    vistas: 19300,
    compartidos: 8420,
    scoreTotal: 4630,
    tags: ['rock', 'guitarra', 'solo', 'improvisación', 'épico'],
    fuenteUrl: '/host/andres-castillo',
  },
  {
    id: 9,
    titulo: 'La Mejor Anécdota Radiofónica — Gabriela Hizo Llorar a Todo el Estudio',
    fuente: 'concurso',
    duracion: '60',
    duracionSegundos: 60,
    descripcion: 'Gabriela Mora ganó el concurso de la mejor anécdota radiofónica con una historia sobre su familia, un túnel, y una canción que todos cantaron a capela. Su audio mensaje emocionó tanto a los locutores que el clip se volvió tendencia en menos de una hora. La comunidad lo compartió más de 8000 veces.',
    radioNombre: 'Radio Élite Digital',
    radioFrecuencia: '96.1 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Digital%20elite%20radio%20station%20square%20logo%2C%20modern%20tech%20and%20broadcast%20fusion%2C%20sleek%20silver%20and%20teal%20emblem%2C%20professional%20clean%20flat%20vector&width=120&height=120&seq=clips-logo-elite&orientation=squarish',
    locutorNombre: 'Gabriela Mora',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Young%20professional%20Latina%20woman%20portrait%2C%20business%20casual%2C%20confident%20warm%20smile%2C%20soft%20studio%20light%2C%20clean%20background&width=80&height=80&seq=clips-avatar-gmora&orientation=squarish',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Emotional%20radio%20studio%20moment%2C%20host%20with%20hand%20on%20heart%20moved%20by%20story%2C%20warm%20intimate%20lighting%2C%20tissue%20box%20on%20desk%2C%20genuine%20emotional%20reaction%2C%20heartfelt%20broadcast%20photography&width=1600&height=900&seq=clips-img-anecdota&orientation=landscape',
    fechaCreacion: '2026-06-14T10:30:00',
    esTendencia: true,
    vistas: 26700,
    compartidos: 11340,
    scoreTotal: 6230,
    tags: ['anécdota', 'concurso', 'emocionante', 'familia'],
    fuenteUrl: '/radio/96.1',
  },
  {
    id: 10,
    titulo: 'Carlos Mendoza — 20 Años en la Radio y el Audio que lo Hizo Llorar',
    fuente: 'entrevista',
    duracion: '60',
    duracionSegundos: 60,
    descripcion: 'Durante la entrevista por sus 20 años de trayectoria, Carlos Mendoza recibió un audio sorpresa de su primer oyente, que lo escucha desde el día uno. La reacción de Carlos, con lágrimas y sin poder hablar por casi un minuto, es uno de los momentos más genuinos jamás captados en RFW.',
    radioNombre: 'Banda Radio MX',
    radioFrecuencia: '107.9 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Mexican%20banda%20radio%20station%20square%20logo%2C%20trumpet%20and%20drum%20icon%2C%20festive%20vibrant%20emblem%2C%20cultural%20flat%20vector%20style&width=120&height=120&seq=clips-logo-banda&orientation=squarish',
    locutorNombre: 'Carlos Mendoza',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Mexican%20male%20radio%20host%20portrait%2C%20traditional%20style%2C%20warm%20smile%2C%20festive%20studio%20background%2C%20natural%20lighting&width=80&height=80&seq=clips-avatar-cmendoza&orientation=squarish',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Veteran%20radio%20host%20emotional%20moment%20in%20warm%20studio%2C%20wall%20of%20career%20memorabilia%2C%20golden%20anniversary%20decorations%2C%20genuine%20tears%20of%20joy%2C%20heartfelt%20nostalgic%20atmosphere%2C%20documentary%20photography%20style&width=1600&height=900&seq=clips-img-20anos&orientation=landscape',
    fechaCreacion: '2026-06-13T15:45:00',
    esTendencia: true,
    vistas: 31200,
    compartidos: 14560,
    scoreTotal: 8010,
    tags: ['trayectoria', 'emoción', 'aniversario', 'oyentes'],
    fuenteUrl: '/radio/107.9',
    canonicalSource: { type: 'post', id: 'post-001' },
  },
  {
    id: 11,
    titulo: 'Especial de Medianoche — La Leyenda Urbana que Más Mensajes Generó',
    fuente: 'evento',
    duracion: '180',
    duracionSegundos: 180,
    descripcion: 'Del especial de medianoche de Leyendas Urbanas, este fue el relato que más reacciones generó. Narración inmersiva con efectos de sonido que puso los pelos de punta a toda la comunidad. Tres minutos de historia que después se compartieron en grupos de WhatsApp de toda Centroamérica.',
    radioNombre: 'La Kalle 99.9',
    radioFrecuencia: '99.9 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Pop%20music%20radio%20station%20square%20logo%2C%20neon%20microphone%20icon%2C%20vibrant%20pink%20and%20coral%20emblem%2C%20modern%20flat%20vector&width=120&height=120&seq=clips-logo-kalle2&orientation=squarish',
    locutorNombre: 'Diego Montenegro',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Young%20male%20pop%20radio%20DJ%20portrait%2C%20stylish%20casual%20outfit%2C%20energetic%20smile%2C%20neon%20lit%20studio%20background%2C%20modern%20vibe&width=80&height=80&seq=clips-avatar-dmontenegro2&orientation=squarish',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Eerie%20midnight%20radio%20studio%20with%20dim%20blue%20and%20purple%20atmospheric%20lighting%2C%20vintage%20microphone%20on%20desk%2C%20shadow%20play%20on%20walls%2C%20mysterious%20fog%20effect%2C%20spooky%20storytelling%20atmosphere%2C%20cinematic%20horror%20photography%20style&width=1600&height=900&seq=clips-img-leyenda&orientation=landscape',
    fechaCreacion: '2026-06-12T23:30:00',
    esTendencia: false,
    vistas: 14200,
    compartidos: 6780,
    scoreTotal: 3720,
    tags: ['terror', 'leyendas', 'medianoche', 'misterio'],
    fuenteUrl: '/radio/99.9',
  },
  {
    id: 12,
    titulo: 'Dr. Pedro Gutiérrez — El Consejo de Salud Mental que Todos Necesitaban',
    fuente: 'locutor',
    duracion: '60',
    duracionSegundos: 60,
    descripcion: 'En un segmento de su programa matutino, el Dr. Pedro Gutiérrez compartió una reflexión sobre salud mental y comunidad que resonó profundamente. En menos de 24 horas, el clip acumuló más de 10000 vistas. Los oyentes pidieron que se convierta en una sección fija del programa.',
    radioNombre: 'Radio Élite Digital',
    radioFrecuencia: '96.1 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Digital%20elite%20radio%20station%20square%20logo%2C%20modern%20tech%20and%20broadcast%20fusion%2C%20sleek%20silver%20and%20teal%20emblem%2C%20professional%20clean%20flat%20vector&width=120&height=120&seq=clips-logo-elite2&orientation=squarish',
    locutorNombre: 'Dr. Pedro Gutiérrez',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Male%20doctor%20radio%20host%20portrait%2C%20professional%20calm%20expression%2C%20warm%20natural%20lighting%2C%20studio%20with%20bookshelves%2C%20editorial%20professional%20photography&width=80&height=80&seq=clips-avatar-pgutierrez&orientation=squarish',
    programaNombre: 'Salud y Comunidad',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Warm%20professional%20radio%20studio%20setup%20for%20health%20talk%20show%2C%20comfortable%20armchair%2C%20plants%2C%20soft%20natural%20window%20lighting%2C%20calm%20therapeutic%20atmosphere%2C%20wellness%20podcast%20photography&width=1600&height=900&seq=clips-img-salud&orientation=landscape',
    fechaCreacion: '2026-06-11T09:00:00',
    esTendencia: false,
    vistas: 11300,
    compartidos: 4890,
    scoreTotal: 2690,
    tags: ['salud', 'bienestar', 'consejo', 'comunidad'],
    fuenteUrl: '/host/pedro-gutierrez',
  },
  {
    id: 13,
    titulo: 'El Debut de Javier Solís como Cantante — Nadie lo Vio Venir',
    fuente: 'programa',
    duracion: '30',
    duracionSegundos: 30,
    descripcion: 'Javier Solís, el narrador deportivo más escuchado de RFW, sorprendió a todos cantando el himno nacional en vivo antes de la transmisión de la final. Treinta segundos que demostraron que el talento en RFW no tiene límites. El clip acumuló más de 15000 vistas en un solo día.',
    radioNombre: 'Deportes Total Radio',
    radioFrecuencia: '101.1 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Sports%20radio%20station%20square%20logo%2C%20soccer%20ball%20and%20microphone%20icon%2C%20bold%20dynamic%20emblem%2C%20warm%20red%20and%20gold%20flat%20vector%20style&width=120&height=120&seq=clips-logo-deportes2&orientation=squarish',
    locutorNombre: 'Javier Solís',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Male%20sports%20commentator%20portrait%2C%20professional%20headset%2C%20enthusiastic%20expression%2C%20broadcast%20booth%2C%20dramatic%20stadium%20lighting&width=80&height=80&seq=clips-avatar-jsolis2&orientation=squarish',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Sports%20commentator%20singing%20passionately%20at%20stadium%20broadcast%20booth%2C%20dramatic%20stadium%20lights%20behind%2C%20emotional%20performance%20moment%2C%20surprised%20colleagues%20in%20background%2C%20epic%20sports%20photography&width=1600&height=900&seq=clips-img-debut&orientation=landscape',
    fechaCreacion: '2026-06-10T16:00:00',
    esTendencia: false,
    vistas: 16200,
    compartidos: 7100,
    scoreTotal: 3910,
    tags: ['deportes', 'canto', 'sorpresa', 'talento oculto'],
    fuenteUrl: '/host/javier-solis',
  },
  {
    id: 14,
    titulo: 'Entrevista al Equipo RFW — La Historia que Nadie Conocía',
    fuente: 'entrevista',
    duracion: '180',
    duracionSegundos: 180,
    descripcion: 'Por primera vez, el equipo fundador de RFW contó cómo empezó todo. Tres minutos de historia pura: la idea inicial, los desafíos, las noches sin dormir y el momento exacto en que supieron que estaban construyendo algo grande. Un clip que inspiró a locutores y oyentes por igual.',
    radioNombre: 'RFW Radio',
    radioFrecuencia: '87.00 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Official%20RFW%20network%20square%20logo%2C%20radio%20frequency%20waves%20emblem%2C%20warm%20red%20and%20amber%20gradient%2C%20professional%20broadcast%20identity%2C%20clean%20modern%20flat%20vector&width=120&height=120&seq=clips-logo-rfw2&orientation=squarish',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Modern%20creative%20office%20studio%20with%20broadcast%20equipment%2C%20diverse%20team%20collaborating%20around%20table%2C%20warm%20ambient%20lighting%2C%20startup%20culture%20photography%2C%20professional%20behind%20the%20scenes%2C%20authentic%20documentary%20style&width=1600&height=900&seq=clips-img-equipo&orientation=landscape',
    fechaCreacion: '2026-06-09T11:00:00',
    esTendencia: false,
    vistas: 9800,
    compartidos: 4120,
    scoreTotal: 2260,
    tags: ['RFW', 'historia', 'equipo', 'inspiración'],
    fuenteUrl: '/radio/87.00',
    canonicalSource: { type: 'post', id: 'post-017' },
  },
  {
    id: 15,
    titulo: 'Noche de Rock Nacional — La Banda que Todos Quieren Volver a Escuchar',
    fuente: 'evento',
    duracion: '60',
    duracionSegundos: 60,
    descripcion: 'De la Noche de Rock Nacional, la banda Los Ecos del Valle se robó el show con una presentación que dejó a todos pidiendo más. Sesenta segundos de rock costarricense puro que demostraron el talento que hay en el país. El clip se convirtió en la puerta de entrada de nuevos oyentes a Rock Total Radio.',
    radioNombre: 'Rock Total Radio',
    radioFrecuencia: '95.3 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Rock%20radio%20station%20square%20logo%2C%20electric%20guitar%20silhouette%2C%20bold%20dynamic%20emblem%2C%20edgy%20flat%20vector%20style&width=120&height=120&seq=clips-logo-rock2&orientation=squarish',
    locutorNombre: 'Andrés Castillo',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Rock%20radio%20host%20male%20portrait%2C%20leather%20jacket%2C%20confident%20expression%2C%20studio%20with%20guitars%20on%20wall%2C%20edgy%20lighting&width=80&height=80&seq=clips-avatar-acastillo2&orientation=squarish',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Live%20rock%20band%20performing%20energetically%20in%20radio%20studio%2C%20electric%20guitars%20and%20drum%20set%2C%20dramatic%20red%20and%20blue%20stage%20lighting%2C%20intimate%20concert%20vibe%2C%20music%20performance%20photography%2C%20raw%20rock%20atmosphere&width=1600&height=900&seq=clips-img-rocknacional&orientation=landscape',
    fechaCreacion: '2026-06-08T20:00:00',
    esTendencia: true,
    vistas: 19800,
    compartidos: 8670,
    scoreTotal: 4760,
    tags: ['rock', 'nacional', 'bandas', 'descubrimiento'],
    fuenteUrl: '/radio/95.3',
  },
  {
    id: 16,
    titulo: 'Mauricio Chaves — El Audio que Hizo Llorar a Valentina en Vivo',
    fuente: 'concurso',
    duracion: '30',
    duracionSegundos: 30,
    descripcion: 'Mauricio desde Guanacaste mandó un audio mensaje para el cumpleaños de su hija Valentina (sí, le puso Valentina por la locutora). La reacción de Valentina Ríos al escuchar a la pequeña cantando su canción favorita fue de lágrimas genuinas en vivo. Uno de los momentos más tiernos de Tardes con Vale.',
    radioNombre: 'Estéreo Capital',
    radioFrecuencia: '102.1 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Modern%20radio%20station%20square%20logo%2C%20clean%20minimalist%20design%2C%20warm%20golden%20and%20amber%20emblem%2C%20broadcast%20waves%20icon%2C%20elegant%20flat%20vector%20style&width=120&height=120&seq=clips-logo-capital3&orientation=squarish',
    locutorNombre: 'Valentina Ríos',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20portrait%2C%20warm%20confident%20smile%2C%20modern%20studio%20headphones%2C%20broadcast%20booth%20background%2C%20soft%20natural%20lighting%2C%20editorial%20style&width=80&height=80&seq=clips-avatar-vrios2&orientation=squarish',
    programaNombre: 'Tardes con Vale',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Female%20radio%20host%20emotional%20moment%2C%20holding%20tissue%20to%20eyes%2C%20genuine%20tears%20of%20joy%2C%20warm%20studio%20lighting%2C%20birthday%20decorations%20in%20background%2C%20heartfelt%20authentic%20broadcast%20moment%2C%20documentary%20photography&width=1600&height=900&seq=clips-img-llorar&orientation=landscape',
    fechaCreacion: '2026-06-07T17:30:00',
    esTendencia: false,
    vistas: 24500,
    compartidos: 10980,
    scoreTotal: 6030,
    tags: ['emoción', 'cumpleaños', 'ternura', 'oyentes'],
    fuenteUrl: '/radio/102.1',
  },
  {
    id: 17,
    titulo: 'El Fail Más Divertido de la Radio — Diego Montenegro en Offside',
    fuente: 'locutor',
    duracion: '15',
    duracionSegundos: 15,
    descripcion: 'Diego Montenegro protagonizó el fail más divertido del mes cuando se equivocó de canción al aire y terminó reproduciendo un audio que no era. Quince segundos de risa genuina y complicidad con la comunidad que se volvieron el clip más compartido del día. La comunidad ama cuando los locutores son humanos.',
    radioNombre: 'La Kalle 99.9',
    radioFrecuencia: '99.9 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Pop%20music%20radio%20station%20square%20logo%2C%20neon%20microphone%20icon%2C%20vibrant%20pink%20and%20coral%20emblem%2C%20modern%20flat%20vector&width=120&height=120&seq=clips-logo-kalle3&orientation=squarish',
    locutorNombre: 'Diego Montenegro',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Young%20male%20pop%20radio%20DJ%20portrait%2C%20stylish%20casual%20outfit%2C%20laughing%20expression%2C%20neon%20lit%20studio%20background%2C%20modern%20vibe&width=80&height=80&seq=clips-avatar-dmontenegro3&orientation=squarish',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Radio%20host%20laughing%20at%20own%20mistake%20in%20studio%2C%20hand%20covering%20face%20in%20embarrassment%2C%20colorful%20neon%20studio%20lighting%2C%20funny%20candid%20moment%2C%20authentic%20broadcast%20blooper%20photography&width=1600&height=900&seq=clips-img-fail&orientation=landscape',
    fechaCreacion: '2026-06-06T14:45:00',
    esTendencia: true,
    vistas: 32100,
    compartidos: 15670,
    scoreTotal: 8620,
    tags: ['fail', 'humor', 'blooper', 'viral'],
    fuenteUrl: '/host/diego-montenegro',
  },
  {
    id: 18,
    titulo: 'Mariana Vega Lee un Poema de un Oyente — El Silencio que Siguió',
    fuente: 'programa',
    duracion: '30',
    duracionSegundos: 30,
    descripcion: 'Mariana Vega recibió un poema de un oyente de 82 años que escucha Radio Cultural CR desde su fundación. Al leerlo al aire, se hizo un silencio de varios segundos que lo dijo todo. Treinta segundos que recordaron por qué la radio cultural tiene un lugar especial en el corazón de la gente.',
    radioNombre: 'Radio Cultural CR',
    radioFrecuencia: '94.3 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Cultural%20radio%20station%20square%20logo%2C%20book%20and%20flower%20icon%2C%20elegant%20teal%20and%20gold%20emblem%2C%20classic%20flat%20vector%20style&width=120&height=120&seq=clips-logo-cultural&orientation=squarish',
    locutorNombre: 'Mariana Vega',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Female%20cultural%20radio%20host%20portrait%2C%20elegant%20warm%20smile%2C%20sophisticated%20casual%20style%2C%20artsy%20studio%20background%2C%20soft%20natural%20lighting&width=80&height=80&seq=clips-avatar-mvega&orientation=squarish',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Radio%20host%20reading%20poem%20with%20emotion%20in%20elegant%20cultural%20studio%2C%20warm%20library-like%20atmosphere%20with%20bookshelves%2C%20soft%20golden%20lighting%2C%20reflective%20quiet%20moment%2C%20artistic%20broadcast%20photography&width=1600&height=900&seq=clips-img-poema&orientation=landscape',
    fechaCreacion: '2026-06-05T10:00:00',
    esTendencia: false,
    vistas: 8900,
    compartidos: 3450,
    scoreTotal: 1890,
    tags: ['poesía', 'cultural', 'emoción', 'oyentes'],
    fuenteUrl: '/radio/94.3',
  },
  {
    id: 19,
    titulo: 'El Concurso Relámpago que Rompió Récords de Participación',
    fuente: 'concurso',
    duracion: '15',
    duracionSegundos: 15,
    descripcion: 'El concurso relámpago con la pregunta más difícil de la historia de RFW. Solo 3 personas acertaron entre más de 800 participantes. Quince segundos que muestran la emoción del momento en que se anunció al ganador. La comunidad entró en ebullición con más de 3000 reacciones en un minuto.',
    radioNombre: 'Radio Deportiva Total',
    radioFrecuencia: '101.1 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Sports%20radio%20station%20square%20logo%2C%20soccer%20ball%20and%20microphone%20icon%2C%20bold%20dynamic%20emblem%2C%20warm%20red%20and%20gold%20flat%20vector%20style&width=120&height=120&seq=clips-logo-deportes3&orientation=squarish',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Exciting%20radio%20contest%20moment%20in%20broadcast%20studio%2C%20host%20announcing%20winner%20with%20envelope%2C%20confetti%20and%20celebration%2C%20dynamic%20studio%20lighting%2C%20game%20show%20atmosphere%20photography&width=1600&height=900&seq=clips-img-concurso&orientation=landscape',
    fechaCreacion: '2026-06-04T16:15:00',
    esTendencia: false,
    vistas: 13400,
    compartidos: 5670,
    scoreTotal: 3110,
    tags: ['concurso', 'récord', 'participación', 'premio'],
    fuenteUrl: '/eventos',
  },
  {
    id: 20,
    titulo: '100 Programas de Tardes con Vale — El Mejor Momento de la Celebración',
    fuente: 'programa',
    duracion: '60',
    duracionSegundos: 60,
    descripcion: 'En la celebración de los 100 programas de Tardes con Vale, Valentina Ríos recibió una sorpresa de sus oyentes más fieles: un video compilatorio con mensajes de 50 oyentes diferentes agradeciéndole por acompañarlos. Su reacción viéndolo en vivo es el clip más emotivo de la historia del programa.',
    radioNombre: 'Estéreo Capital',
    radioFrecuencia: '102.1 RFW',
    radioLogo: 'https://readdy.ai/api/search-image?query=Modern%20radio%20station%20square%20logo%2C%20clean%20minimalist%20design%2C%20warm%20golden%20and%20amber%20emblem%2C%20broadcast%20waves%20icon%2C%20elegant%20flat%20vector%20style&width=120&height=120&seq=clips-logo-capital4&orientation=squarish',
    locutorNombre: 'Valentina Ríos',
    locutorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20portrait%2C%20warm%20confident%20smile%2C%20modern%20studio%20headphones%2C%20broadcast%20booth%20background%2C%20soft%20natural%20lighting%2C%20editorial%20style&width=80&height=80&seq=clips-avatar-vrios3&orientation=squarish',
    programaNombre: 'Tardes con Vale',
    imagenUrl: 'https://readdy.ai/api/search-image?query=Celebration%20themed%20radio%20studio%20with%20gold%20balloons%20and%20confetti%2C%20female%20host%20watching%20surprise%20video%20on%20monitor%20with%20emotional%20reaction%2C%20champagne%20glasses%20on%20broadcast%20desk%2C%20warm%20golden%20festive%20lighting%2C%20milestone%20celebration%20atmosphere%2C%20joyful%20event%20photography&width=1600&height=900&seq=clips-img-100&orientation=landscape',
    fechaCreacion: '2026-06-03T17:00:00',
    esTendencia: false,
    vistas: 17600,
    compartidos: 7890,
    scoreTotal: 4340,
    tags: ['aniversario', '100 programas', 'sorpresa', 'Tardes con Vale'],
    fuenteUrl: '/radio/102.1',
  },
];

export const scoreAccionesClips: ScoreAccionClip[] = [
  {
    id: 'ver',
    accion: 'Ver Clip',
    icono: 'ri-play-circle-line',
    color: 'from-rose-500 to-amber-500',
    descripcion: 'Cada vez que un oyente mira tu clip, suma puntos. Los clips más vistos ganan visibilidad automática en TV App.',
    puntos: 10,
  },
  {
    id: 'compartir',
    accion: 'Compartir Clip',
    icono: 'ri-share-forward-line',
    color: 'from-emerald-500 to-teal-500',
    descripcion: 'Compartir un clip en redes sociales o dentro de RFW multiplica su alcance. Cada compartido suma puntos al creador.',
    puntos: 15,
  },
  {
    id: 'tendencia',
    accion: 'Clip en Tendencia',
    icono: 'ri-fire-line',
    color: 'from-violet-500 to-purple-500',
    descripcion: 'Cuando un clip alcanza el umbral de tendencia, recibe un bonus de puntos y se destaca en todas las superficies de descubrimiento.',
    puntos: 50,
  },
  {
    id: 'descubrir',
    accion: 'Descubrir Nueva Radio',
    icono: 'ri-compass-3-line',
    color: 'from-amber-500 to-orange-500',
    descripcion: 'Si un oyente descubre una radio nueva a través de un clip y la sintoniza, el clip recibe puntos extra de descubrimiento.',
    puntos: 25,
  },
];

export const reglasClips: ReglaClip[] = [
  {
    id: 1,
    titulo: 'Los clips deben impulsar descubrimiento',
    descripcion: 'Cada clip existe para que nuevos oyentes descubran radios, programas, locutores y eventos que no conocían. El clip es la puerta de entrada. No es contenido aislado: es un puente hacia la radio que lo originó. El objetivo no es solo entretener — es hacer que quien lo vea quiera sintonizar.',
    icono: 'ri-compass-3-line',
    gradiente: 'from-rose-500 to-amber-500',
  },
  {
    id: 2,
    titulo: 'Duración pensada para cada plataforma',
    descripcion: '15 segundos para Stories y reels. 30 segundos para clips rápidos de alto impacto. 60 segundos para momentos con más contexto. 3 minutos para entrevistas, debates y contenido profundo. Cada duración tiene su propósito y su plataforma ideal de distribución.',
    icono: 'ri-timer-line',
    gradiente: 'from-emerald-500 to-teal-500',
  },
  {
    id: 3,
    titulo: 'Los clips más vistos y compartidos ganan visibilidad',
    descripcion: 'El algoritmo de descubrimiento prioriza automáticamente los clips con más vistas y compartidos. No hay intervención manual. La comunidad decide qué clips merecen estar en el carrusel principal de TV App, en la landing y en las superficies de descubrimiento.',
    icono: 'ri-fire-line',
    gradiente: 'from-violet-500 to-purple-500',
  },
  {
    id: 4,
    titulo: 'Cada clip linkea a su fuente original',
    descripcion: 'Todo clip tiene un enlace directo a la radio, programa, locutor o evento que lo originó. El descubrimiento no termina en el clip — empieza ahí. Un clic lleva al oyente a sintonizar la radio, seguir al locutor o participar del evento. El clip es el inicio del viaje, no el destino.',
    icono: 'ri-links-line',
    gradiente: 'from-amber-500 to-orange-500',
  },
];

export const globalStatsClips = {
  totalClips: clips.length,
  clipsEnTendencia: clips.filter(c => c.esTendencia).length,
  totalVistas: clips.reduce((acc, c) => acc + c.vistas, 0),
  totalCompartidos: clips.reduce((acc, c) => acc + c.compartidos, 0),
  scoreTotalGenerado: clips.reduce((acc, c) => acc + c.scoreTotal, 0),
  clipMasVisto: 'Diego Vargas - Cover de Bailando (45,210 vistas)',
  clipMasCompartido: 'Diego Vargas - Cover de Bailando (23,450 compartidos)',
  radioConMasClips: 'Estéreo Capital (5 clips)',
};

export const fuenteLabels: Record<FuenteClip, { label: string; icono: string; color: string }> = {
  programa: { label: 'Programa', icono: 'ri-mic-line', color: 'text-rose-600 bg-rose-100' },
  locutor: { label: 'Locutor', icono: 'ri-user-voice-line', color: 'text-violet-600 bg-violet-100' },
  entrevista: { label: 'Entrevista', icono: 'ri-chat-1-line', color: 'text-amber-600 bg-amber-100' },
  evento: { label: 'Evento', icono: 'ri-calendar-event-line', color: 'text-emerald-600 bg-emerald-100' },
  concurso: { label: 'Concurso', icono: 'ri-trophy-line', color: 'text-sky-600 bg-sky-100' },
};

export const duracionLabels: Record<DuracionClip, { label: string; descripcion: string; color: string; bg: string }> = {
  '15': { label: '15s', descripcion: 'Stories y reels', color: 'text-foreground-600', bg: 'bg-foreground-100' },
  '30': { label: '30s', descripcion: 'Clips rápidos', color: 'text-rose-600', bg: 'bg-rose-100' },
  '60': { label: '60s', descripcion: 'Momentos destacados', color: 'text-amber-600', bg: 'bg-amber-100' },
  '180': { label: '3 min', descripcion: 'Contenido profundo', color: 'text-violet-600', bg: 'bg-violet-100' },
};

export function getClipsPorFuente(fuente: FuenteClip): Clip[] {
  return clips.filter(c => c.fuente === fuente);
}

export function getClipsPorDuracion(duracion: DuracionClip): Clip[] {
  return clips.filter(c => c.duracion === duracion);
}

export function getClipsEnTendencia(): Clip[] {
  return clips.filter(c => c.esTendencia);
}

export function getMasVistos(): Clip[] {
  return [...clips].sort((a, b) => b.vistas - a.vistas);
}

export function getMasCompartidos(): Clip[] {
  return [...clips].sort((a, b) => b.compartidos - a.compartidos);
}

export function getPorTendencia(): Clip[] {
  return [...clips].sort((a, b) => (b.esTendencia ? 1 : 0) - (a.esTendencia ? 1 : 0) || b.vistas - a.vistas);
}

export function getMasRecientes(): Clip[] {
  return [...clips].sort((a, b) => new Date(b.fechaCreacion).getTime() - new Date(a.fechaCreacion).getTime());
}

export function formatearNumero(n: number): string {
  if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}K`;
  return n.toString();
}